import { Link, useRouter } from "@tanstack/react-router";

export function RouteError({ error, reset }: { error: Error; reset: () => void }) {
  const router = useRouter();
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center px-6 py-24 text-center">
      <p className="editorial-eyebrow text-muted-foreground">Something went wrong</p>
      <h1 className="mt-3 font-serif text-3xl">We couldn't load this page</h1>
      <p className="mt-3 text-sm text-muted-foreground">{error.message || "Unexpected error."}</p>
      <div className="mt-6 flex gap-3">
        <button
          onClick={() => { router.invalidate(); reset(); }}
          className="bg-foreground px-4 py-2 text-xs uppercase tracking-widest text-background hover:bg-accent"
        >
          Try again
        </button>
        <Link to="/" className="border border-border px-4 py-2 text-xs uppercase tracking-widest hover:bg-card">
          Go home
        </Link>
      </div>
    </div>
  );
}

export function RouteNotFound() {
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center px-6 py-24 text-center">
      <p className="editorial-eyebrow text-muted-foreground">404</p>
      <h1 className="mt-3 font-serif text-3xl">Not found</h1>
      <p className="mt-3 text-sm text-muted-foreground">The page or item you're looking for doesn't exist.</p>
      <Link to="/" className="mt-6 border border-border px-4 py-2 text-xs uppercase tracking-widest hover:bg-card">
        Go home
      </Link>
    </div>
  );
}